import type { ReactNode } from 'react';

interface TabsProps {
  children: ReactNode;
  variant?: 'default' | 'segment';
  className?: string;
}

export function Tabs({ children, variant = 'default', className = '' }: TabsProps) {
  const baseClasses =
    variant === 'segment'
      ? 'flex p-1 bg-surface-sunken rounded-lg gap-1'
      : 'flex border-b border-edge-subtle gap-4';

  return (
    <div className={`${baseClasses} ${className}`} role="tablist">
      {children}
    </div>
  );
}

interface TabProps {
  children: ReactNode;
  active?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

export function Tab({ children, active, onClick, disabled }: TabProps) {
  const activeClasses = active
    ? 'bg-surface-base text-primary-700 shadow-sm'
    : 'text-content-tertiary hover:text-content-secondary hover:bg-surface-sunken';

  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      disabled={disabled}
      onClick={onClick}
      className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all ${activeClasses} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      {children}
    </button>
  );
}
